import { Image } from '@educator/components/Image'
import { getBasePath } from '@educator/config/basePath'
import type { SubjectDetailItem } from '@educator/types/subjects'
import type { HeroStripConfig } from '@educator/utils/deriveHeroStrip'
import { useTranslation } from '@mc/i18n'
import { SectionContainer } from '../../SectionContainer'
import { applyEnrollmentStateDetails } from '../../utils/applyEnrollmentStateDetails'

interface SubjectDetailBarProps {
  details: SubjectDetailItem[]
  partnerLogoAlt: string
  heroStrip?: HeroStripConfig
}

export const SubjectDetailBar = ({
  details,
  partnerLogoAlt,
  heroStrip,
}: SubjectDetailBarProps) => {
  const { t } = useTranslation('@mc/educator')
  const basePath = getBasePath()
  const effectiveDetails = applyEnrollmentStateDetails({
    details,
    heroStrip,
    t,
  })

  return (
    <section
      data-section='subject-detail-bar'
      className='hidden md:block w-full pt-4 pb-8 '
    >
      <SectionContainer>
        <div className='grid md:grid-cols-3 md:gap-x-8 md:gap-y-10 lg:grid-cols-5 lg:gap-x-0 lg:gap-y-0'>
          {effectiveDetails.map((item) => (
            <div key={item.label} className='flex flex-col gap-3'>
              <span className='text-label-2 uppercase leading-label-2 tracking-[1.2px] font-semibold text-white'>
                {item.label}
              </span>
              <span className='text-body-1 leading-body-1 text-white'>
                {item.value}
              </span>
            </div>
          ))}
          <div className='flex flex-col gap-3'>
            <span className='text-label-2 uppercase leading-label-2 tracking-[1.2px] font-semibold text-white'>
              {t('enrollment.hero.partnerLabel')}
            </span>
            <Image
              src={`${basePath}/images/chicago-booth-white.svg`}
              alt={partnerLogoAlt}
              width={122}
              height={28}
            />
          </div>
        </div>
      </SectionContainer>
    </section>
  )
}
